// extracted by mini-css-extract-plugin
export default {"dropdown__profile__container":"DropdownProfile_dropdown__profile__container__QnB8y","dropdown__profile__menu":"DropdownProfile_dropdown__profile__menu__rryZf"};